module.exports = __webpack_public_path__ + "static/img_2.3aee8b6c.jpg";